import { render, staticRenderFns } from "./jiuye.vue?vue&type=template&id=c47187cc&scoped=true"
import script from "./jiuye.vue?vue&type=script&lang=js"
export * from "./jiuye.vue?vue&type=script&lang=js"
import style0 from "./jiuye.vue?vue&type=style&index=0&id=c47187cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47187cc",
  null
  
)

export default component.exports